import React from 'react';
import { Modal } from './modal';
import { Button } from './button';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { cn } from '../../utils/cn';

interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'danger' | 'warning' | 'info';
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'danger'
}) => {
  const getTypeStyles = () => {
    switch (type) {
      case 'danger':
        return {
          icon: 'text-red-500',
          bg: 'bg-red-500/10',
          border: 'border-red-500/20',
          button: 'bg-red-500 hover:bg-red-600 text-white'
        };
      case 'warning':
        return {
          icon: 'text-yellow-500',
          bg: 'bg-yellow-500/10',
          border: 'border-yellow-500/20',
          button: 'bg-yellow-500 hover:bg-yellow-600 text-white'
        };
      default:
        return {
          icon: 'text-blue-500',
          bg: 'bg-blue-500/10',
          border: 'border-blue-500/20',
          button: 'bg-blue-500 hover:bg-blue-600 text-white'
        };
    }
  };

  const styles = getTypeStyles();

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} description={description}>
      <div className="p-6">
        <div className={cn("rounded-xl p-4 mb-6", styles.bg, styles.border)}>
          <div className="flex items-center gap-3">
            <div className={cn("p-2 rounded-lg", styles.bg)}>
              <ExclamationTriangleIcon className={cn("h-5 w-5", styles.icon)} />
            </div>
            <div>
              <p className="text-muted-foreground">Please confirm this action</p>
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-4">
          <Button
            variant="outline"
            onClick={onClose}
          >
            {cancelText}
          </Button>
          <Button
            className={styles.button}
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};